import { render, staticRenderFns } from "./SettingsMonitor.vue?vue&type=template&id=3b65e854"
import script from "./SettingsMonitor.vue?vue&type=script&lang=js"
export * from "./SettingsMonitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports